import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Ashley R.',
  location: 'Austin, TX'
}, {
  name: 'Jessica M.',
  location: 'Denver, CO'
}, {
  name: 'Emily T.',
  location: 'Portland, OR'
}, {
  name: 'Sophia K.',
  location: 'Nashville, TN'
}, {
  name: 'Olivia B.',
  location: 'Scottsdale, AZ'
}, {
  name: 'Chloe S.',
  location: 'San Diego, CA'
}, {
  name: 'Mia L.',
  location: 'Miami, FL'
}, {
  name: 'Isabella C.',
  location: 'Seattle, WA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed top-4 right-4 z-50 animate-slide-in" data-id="element-192">
          <div className="bg-white border-2 border-brand-rose shadow-2xl rounded-lg p-3 pr-8 max-w-[280px] relative overflow-hidden" data-id="element-193">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-rose via-brand-gold to-brand-rose" data-id="element-194"></div>
            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-gray-400 hover:text-brand-graphite transition-colors" data-id="element-195">
              <XIcon className="w-3.5 h-3.5" data-id="element-196" />
            </button>
            <div className="flex items-center gap-3" data-id="element-197">
              <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center shrink-0 border border-brand-rose/30" data-id="element-198">
                <ShoppingBag className="w-5 h-5 text-brand-rose" data-id="element-199" />
              </div>
              <div className="leading-tight" data-id="element-200">
                <p className="font-bold text-brand-graphite text-sm" data-id="element-201">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-gray-500 font-medium" data-id="element-202">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-petrol font-bold mt-0.5" data-id="element-203">
                  just purchased YOGA READY™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}